import { Archive, Flame, Map } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "#/components/ui/card";

import { PremiumSubscribeActions } from "./-premium.subscribeActions";

const PREMIUM_FEATURES: {
  icon: LucideIcon;
  title: string;
  description: string;
}[] = [
  {
    icon: Map,
    title: "Daily premium map",
    description:
      "One map not enough? Premium subscribers get access to a harder premium map every day.",
  },
  {
    icon: Archive,
    title: "Full archive access",
    description: "Missed a day or two? Replay any past map through the archive.",
  },
  {
    icon: Flame,
    title: "14-day free trial",
    description: "Get a taste of premium with a 14-day free trial. No commitment, cancel anytime.",
  },
];

function PremiumFeatureItem({
  icon: Icon,
  title,
  description,
}: {
  icon: LucideIcon;
  title: string;
  description: string;
}) {
  return (
    <li className="flex gap-3">
      <div className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-muted ring-1 ring-foreground/10">
        <Icon className="size-4 text-foreground" aria-hidden />
      </div>
      <div className="flex min-w-0 flex-col gap-0.5">
        <p className="font-medium text-foreground">{title}</p>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
    </li>
  );
}

export function PremiumOfferCard({ manageBilling }: { manageBilling?: ReactNode }) {
  return (
    <Card className="w-full max-w-lg ring-premium/25">
      <CardHeader className="items-center text-center">
        <CardTitle className="text-2xl font-semibold tracking-tight">Why Premium?</CardTitle>
      </CardHeader>
      <CardContent>
        <ul className="flex flex-col gap-5">
          {PREMIUM_FEATURES.map((feature) => (
            <PremiumFeatureItem key={feature.title} {...feature} />
          ))}
        </ul>
      </CardContent>
      <CardFooter className="flex-col gap-4">
        <PremiumSubscribeActions className="w-full" />
        {manageBilling}
      </CardFooter>
    </Card>
  );
}
